import React, { useState } from 'react';
import SalesReport from './SalesReport';          // Import your sales report component
import PurchaseReport from './PurchaseReport';    // Import your purchase report component
// import ExpenseReport from './ExpenseReport';   // Uncomment when ready to add
import BackButton from '../components/BackButton';
export default function ReportsPage() {
  const [reportType, setReportType] = useState('sales');

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="fw-bold mb-0" style={{ letterSpacing: 1, color: '#3764b2' }}>
          View Reports
        </h3>
        <BackButton></BackButton>
      </div>
      <div className="row mb-4">
        <div className="col-auto">
          <select
            value={reportType}
            onChange={e => setReportType(e.target.value)}
            className="form-select rounded-pill px-3"
            style={{ minWidth: 220, fontWeight: 600, fontSize: 17 }}
          >
            <option value="sales">Sales Report</option>
            <option value="purchase">Purchase Report</option>
            {/* <option value="expense">Expense Report</option> */}
          </select>
        </div>
      </div>

      <div className="mt-2">
        {reportType === 'sales' && <SalesReport />}
        {reportType === 'purchase' && <PurchaseReport />}
        {/* {reportType === 'expense' && <ExpenseReport />} */}
      </div>
    </div>
  );
}
